import {EventHandler} from "../EventDispatcher";
import {IpcMainInvokeEvent} from "electron";
import DocumentDownload from "../../Entity/DocumentDownload";
import getEventDispatcher from "../../DependencyInjection/eventDispatcher";

const eventDispatcher = getEventDispatcher();

const ResumeDownloadListener: EventHandler<DocumentDownload> = async (event: IpcMainInvokeEvent, content: DocumentDownload): Promise<void> => {
    const document: DocumentDownload = DocumentDownload.from(content);

    try {
        await eventDispatcher.dispatch('ResumeDownloadManager');
    } catch (error) {
    }

    await eventDispatcher.dispatch('ResumeDownloadAction');
    await eventDispatcher.dispatch('ChangeDocumentStatusToDownloading', document);
}

export default ResumeDownloadListener;